import React from "react";
import { Box, Fade } from "@material-ui/core";
export const MarkerIcon = ({ visible = true, children, title }) => {
    return (React.createElement(Fade, { in: visible },
        React.createElement(Box, { position: "absolute", width: "100%", height: "100%", display: "flex", alignItems: "center", justifyContent: "center", title: title }, children)));
};
